export var productUrlByCode = {
    rc1: "https://plataforma.rockcontent.com",
    rc2: "https://studio.rockcontent.com",
    studio: "https://studio.rockcontent.com",
    ion: "https://ion.rockcontent.com",
    "global talent network": "https://gtn.rockcontent.com",
    live: "https://live.rockcontent.com",
    stage: "https://stage.rockcontent.com",
    iclips: "https://studio.rockcontent.com",
};
